export default __webpack_public_path__ + "static/media/leekmap3.6c862c18.png";